import { BFormCheckboxGroup } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBFormCheckboxGroup when migrating. */
export const EgBFormCheckboxGroup = createEgBootstrapProxy(
  "EgBFormCheckboxGroup",
  BFormCheckboxGroup
);
